import React from 'react';
import { FormControl, FormHelperText } from '@mui/material';
import { Controller } from 'react-hook-form';
import { PhoneInputWrapper } from './phone-input-wrapper';

interface FormInputPhoneProps {
    name: string;
    control: any;
    label: string;
    error?: boolean;
    helperText?: string;
}

const FormInputPhone: React.FC<FormInputPhoneProps> = ({
    name,
    control,
    label,
    error,
    helperText,
}) => {
    return (
        <FormControl
            fullWidth
            error={error}
            variant='outlined'
        >
            <Controller
                name={name}
                control={control}
                render={({ field: { onChange, onBlur, value, ref } }) => (
                    <PhoneInputWrapper
                        label={label}
                        onChange={(value) => onChange(value)}
                        onBlur={onBlur}
                        value={value}
                        ref={ref}
                        error={error}
                        size='large'
                    />
                )}
            />
            {helperText && <FormHelperText>{helperText}</FormHelperText>}
        </FormControl>
    );
};

export default FormInputPhone;
